import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32be83bb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=32be83bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../cache/node/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be83bb",
  null
  
)

export default component.exports